<template>
  <div class="sub-container">
    <div class="list-box">
      <div class="item" v-for="(item,index) in subscriptionList" :key="index">
        <div class="img">
          <img src="./imgs/pic1.png">
        </div>
        <div class="info">
          <div class="name">{{item.name}}</div>
          <div class="order">
            <span class="time">
              <i class="icon icon-clock"></i>
              <span>{{item.time}}</span>
            </span>
            <span class="num">
              <i class="icon icon-watch-people-yellow-2"></i>
              <span>{{item.orderNum | readableNum }}</span>
            </span>
            <span class="btn" :class="item.ifOrder?'ordered':''">{{item.ifOrder?'已订阅':'订阅'}}</span>
          </div>
        </div>
      </div>
      <div class="item no-show" v-for="i in (subscriptionList.length%3?(3 - subscriptionList.length%3):0)" :key="'i'+i"></div>
    </div>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'
  import ScrollBox from '../../components/scrollBox'

  export default {
    mixins:[],
    props:{
    },
    data(){
      return {
        subscriptionList:[{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        },{
          name:'荒野行動、進撃の巨人',
          time:'123123',
          orderNum:123123,
          ifOrder:true,
        }]
      }
    },
    computed:{
    },
    watch:{
    },
    methods: {
      getDict,
    },
    components: {
      alert,ScrollBox,
    },
    mounted(){
      
    },
    created(){
    }
  }
</script>

<style lang="scss" scoped>
  .sub-container{
    width: 100%;
    height: 100%;
    padding: 0.4rem;

    .list-box{
      height: 100%;
      overflow: scroll;

      display: flex;
      flex-flow: wrap;
      justify-content: space-between;
      align-items: flex-start;

      .item{
        $width: 2.8rem;
        /* margin-top: 0.2rem;
        &:nth-child(-n + 3){
          margin-top: 0;
        }
        margin-left: 0.2rem;
        &:nth-child(3n +1){
          margin-left: 0;
        } */
        margin-bottom: 0.2rem;
        &:nth-last-child(-n + 4){
           margin-bottom: 0;
        }

        width: $width;
        // height: $width * 7/5;
        background-color: #fff;
        display: inline-block;
        color: #000;

        .img{
          width:$width;
          height: $width * 8/16;
          img{
            width: 100%;
            height: 100%;
          }
        }

        .info{
          padding: 0.1rem;
          .name{
            font-weight: 600;
            font-size: 0.2rem;
          }
          .order{
            display: flex;
            align-items: center;
            $font-size: 0.17rem;
            font-size: $font-size;
            .icon{
              $size:$font-size *1.2;
              height: $size;
              width: $size;
              vertical-align: bottom;
              margin-right: 0.01rem;

              &.icon-watch-people-yellow-2{
                width: $size *21/19
              }
            }

            .time{}
            .num{
              margin-left: 0.15rem;
              color: #dca029;
              flex: 1;
            }

            .btn{
              display: inline-block;
              height: $font-size*1.7;
              line-height: $font-size*1.7;
              text-align: center;
              width: 0.7rem;
              background-color: #ffc952;
              border-radius: 0.05rem;

              &.ordered{
                background-color: #c8c8cb;
              }

            }
          }
        }
        
      }
      .subscription-info{}
    }
  }


</style>
